import _defineProperty from './../external_lib/@babel/runtime/helpers/esm/defineProperty.js';
import { TOKEN_PREFIX, extract as extract$1 } from './hooks/useCacheToken.js';
import { extract as extract$2, CSS_VAR_PREFIX } from './hooks/useCSSVarRegister.js';
import { STYLE_PREFIX, extract } from './hooks/useStyleRegister.js';
import './util/index.js';
import './StyleContext.js';
_defineProperty(_defineProperty(_defineProperty({}, STYLE_PREFIX, extract), TOKEN_PREFIX, extract$1), CSS_VAR_PREFIX, extract$2);
//# sourceMappingURL=extractStyle.js.map
